import backImg1 from "../../images/back_webtoon_01.png";
import backImg2 from "../../images/back_webtoon_02.png";
import backImg3 from "../../images/back_webtoon_03.png";
import backImg4 from "../../images/back_webtoon_04.png";

const screen_files = [
  backImg1,
  backImg2,
  backImg3,
  backImg4
]

const Webtoon = (props) => {
  return (
    <div>
      {
        screen_files.map((url, index) => (
          <img
            key={index}
            src={url}
            style={{
              width: '100%',
            }}
            alt=""
          />
        ))
      }
    </div>
  );
};

export default Webtoon;
